import { render, staticRenderFns } from "./PorEntregar.vue?vue&type=template&id=2f46b633&"
import script from "./PorEntregar.vue?vue&type=script&lang=js&"
export * from "./PorEntregar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports